import React from 'react';
import createSVG from './createSVG';

const ArrowIcon = ({style}) => (
  <path style={style} fill="none" stroke="#7D7D7D" strokeWidth=".87" d="M15 1L8 15M1 1l7 14" strokeLinecap="round" strokeLinejoin="round"/>
);

export default createSVG(ArrowIcon);
